import { Navigation } from "@mui/icons-material";

type WindDirectionMarkerValueProps = {
  degrees: number;
  label: string;
};

/** Wind-from direction: compass arrow + numeric degrees (matches EDR marker layout). */
export function WindDirectionMarkerValue({
  degrees,
  label,
}: WindDirectionMarkerValueProps) {
  const angle = degrees - 180;

  return (
    <>
      <span
        className="map-marker__value--compass"
        style={{
          display: "inline-flex",
          transform: `rotate(${angle}deg) scale(0.7)`,
        }}
      >
        <Navigation fontSize="small" />
      </span>
      <span>{label}</span>
    </>
  );
}
